import { API_URL } from '../constants';
import { resolveAccessToken } from './Auth';
import { authFetch } from './authFetch';

interface TtsRequestOptions {
  chatId?: string;
  exchangeId?: string;
}

export async function postTts(
  text: string,
  personaId: string,
  accessToken: string,
  opts?: TtsRequestOptions,
  signal?: AbortSignal,
): Promise<Blob> {
  const token = await resolveAccessToken(accessToken);
  if (!token) throw new Error("Session expired");

  const payload: Record<string, unknown> = { personaId, text };
  if (opts?.chatId && opts?.exchangeId) {
    payload.chatId = opts.chatId;
    payload.exchangeId = opts.exchangeId;
  }
  const response = await authFetch(`${API_URL}/tts`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    signal,
  });

  if (!response.ok) {
    const errText = await response.text().catch(() => '');
    throw new Error(`TTS failed (${response.status}): ${errText || response.statusText}`);
  }

  return response.blob();
}

export async function postTtsStream(
  text: string,
  personaId: string,
  accessToken: string,
  opts?: TtsRequestOptions,
  signal?: AbortSignal,
): Promise<Response> {
  const token = await resolveAccessToken(accessToken);
  if (!token) throw new Error("Session expired");

  const payload: Record<string, unknown> = { personaId, text };
  if (opts?.chatId && opts?.exchangeId) {
    payload.chatId = opts.chatId;
    payload.exchangeId = opts.exchangeId;
  }
  const response = await authFetch(`${API_URL}/tts`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    signal,
  });

  if (!response.ok || !response.body) {
    throw new Error(`TTS failed (${response.status})`);
  }

  return response;
}
